export function getDefaultDataTableDefinition(selector: string, overrideSettings: DataTables.Settings) {
  let settings: DataTables.Settings = {
    deferLoading: 1, //manually load the first load so angular doens t throw the ExpressionChangedAfterItHasBeenCheckedError  error
    responsive: false,
    ordering: false,
    searching: false,
    paging: true,
    info: true,
    serverSide: true,
    pagingType: 'full_numbers',
    processing: false,
    pageLength: 25,
    //order:[["firstName", "asc"]],
    dom:
      '<"row"<"col-sm-12"f>>' +
      '<"row"<"col-sm-12"tr>>' +
      '<"row d-none d-sm-flex"<"col-sm-12"<"float-right"p><"float-right neo-dt-l"l>>>' +
      '<"row d-flex d-sm-none"<"col-sm-6"l><"col-sm-6"p>>' +
      '<"row float-right d-none d-sm-flex"<"col-sm-12"<"float-right neo-dt-i"i>>>' +
      '<"row d-flex d-sm-none"<"col-sm-12"i>>',
    language: {
      emptyTable: 'No Matching Records Found.',
      paginate: {
        first: '<<',
        previous: '<',
        next: '>',
        last: '>>'
      },
    }
  };
  Object.assign(settings, overrideSettings);
  return $(selector).DataTable(settings);
}
 
export function getDefaultDataTableDefinitionLocalProcessing(selector: string, overrideSettings: DataTables.Settings) {
  let settings: DataTables.Settings = {
    responsive: false,
    ordering: true,
    searching: true,
    paging: true,
    info: true,
    serverSide: false,
    pagingType: 'full_numbers',
    processing: false,
    pageLength: 25,
    dom:
      '<"row"<"col-sm-12"f>>' +
      '<"row"<"col-sm-12"tr>>' +
      '<"row d-none d-sm-flex"<"col-sm-12"<"float-right"p><"float-right neo-dt-l"l>>>' +
      '<"row d-flex d-sm-none"<"col-sm-6"l><"col-sm-6"p>>' +
      '<"row float-right d-none d-sm-flex"<"col-sm-12"<"float-right neo-dt-i"i>>>' +
      '<"row d-flex d-sm-none"<"col-sm-12"i>>',
    language: {
      emptyTable: 'No Matching Records Found.',
      paginate: {
        first: '<<',
        previous: '<',
        next: '>',
        last: '>>'
      },
    }
  };
  Object.assign(settings, overrideSettings);
  return $(selector).DataTable(settings);
}
